import React, { lazy } from 'react';
import Header from './new_header';
import Hero from './hero_rushcut/Hero.js';
import Vision from './Vision.js';
import ImageFlowBoard from './ImageFlowBoard.js';
const Collaboration = lazy(() => import('./Collaboration.js'));
const Library = lazy(() => import('./Library.js'));
const Inspiration = lazy(() => import('./Inspiration.js'));
const Generation = lazy(() => import('./Generation.js'));
const AnimatedFooterHero = lazy(() => import('./AnimatedFooterHero'));
const FullWidthImage = lazy(() => import('./FullWidthVideo.js'));

export default function SubLogin() {
    return (
        <>
            <Header />
            <Hero />
            <ImageFlowBoard/>
            <Vision />
            <Library />
            <Inspiration />
            <Collaboration />
            <Generation />
            <AnimatedFooterHero />
            <FullWidthImage
                src="./images/black red dot.png"
                alt="rushcut"
            />
        </>
    );
}